import * as utils from "./LocalStorageHelpers";

const localStorageLastLocationKey = "metronic-lastLocation";

function acceptLocation(lastLocation) {
    if (
        lastLocation &&
        lastLocation.pathname &&
        lastLocation.pathname !== "/" &&
        lastLocation.pathname.indexOf("auth") === -1 &&
        lastLocation.pathname !== "/logout"
    ) {
        return true;
    }

    return false;
}

export function saveLastLocation(lastLocation) {
    if (acceptLocation(lastLocation)) {
        utils.setStorage(
            localStorageLastLocationKey,
            JSON.stringify(lastLocation),
            120
        );
    }
}

export function forgotLastLocation() {
    utils.removeStorage(localStorageLastLocationKey);
}

export function getLastLocation() {
    const defaultLocation = { pathname: "/", title: "Dashboard"};
    const localStorateLocations = utils.getStorage(localStorageLastLocationKey);
    if (!localStorateLocations) {
        return { pathname: "/", title: "Dashboard"};
    }

    try {
        const result = JSON.parse(localStorateLocations);
        return result;
    } catch (error) {
        console.error(error);
        return defaultLocation;
    }
}

export function getCurrentUrl(location) {
    return location.pathname.split(/[?#]/)[0];
}

export function checkIsActive(location, url) {
    const current = getCurrentUrl(location);
    if (!current || !url) {
        return  false;
    }

    if (current === url) {
        return  true;
    }

    // Added condition for checking if the "current url" and the url to check are on the first layer
    // Example: "/slots-offline" and "/slots" are 2 different pages but "/slots" will always be in the current url: current.indexOf(url)
    // This caused both pages to be highlighted in the menu
    // The condition for indexOf is necessary for subpages checking; also added that the length of the elements of the current URL to be
    // greater than the length of the elements of the URL to check
    // This way we can differentiate for some URLs that are contained as a whole in other existing URLs

    let currentUrlSections = current.split("/").length;
    let urlSections = url.split("/").length;

    if (current.indexOf(url) > -1 && (currentUrlSections > urlSections)) {
        return true;
    }

    return false;
}
